import _Model from "./_Model";

export default class ServicePlanAssetItem extends _Model {
  constructor(json) {
    super(json);
    this.servicePlanAssetItemKey = json.servicePlanAssetItemKey;
    this.servicePlanAssetKey = json.servicePlanAssetKey;
    this.value = json.value;
    this.labelKey = json.labelKey;
    this.order = json.order;
  }
}
